import React from "react";
import {
  PriceContainer,
  HeadingStyled,
  PriceStyled,
  PackageTimeStyled,
  PriceTimeContainerStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { isChampionsTrophyAddOn } from "../../utils/subscriptionUtils";

class PriceComponent extends React.Component {
  render() {
    const { infoObj } = this.props;

    return (
      <PriceContainer>
        <HeadingStyled
          rank={1}
          text={
            infoObj && infoObj?.CTAddOnData?.isCTStandalone && !infoObj?.isRecurringPlan
              ? i18n.get("pages.brands.inActiveSubscriptions.seasonPass.oneTimePayment")
              : isChampionsTrophyAddOn(infoObj?.CTAddOnData?.name)
              ? i18n.get("pages.buyBrands.getItFor")
              : infoObj?.isBilledOnce
              ? i18n.get("pages.buyBrands.billedOnce")
              : infoObj.paymentPlans && (infoObj.paymentPlans.length === 1 || infoObj?.action === "switch")
              ? i18n.get("pages.buyBrands.getItForJust")
              : infoObj?.isMonthlyPlan
              ? i18n.get("pages.buyBrands.getItFor")
              : infoObj.paymentPlans && i18n.get("pages.buyBrands.startFrom")
          }
          size="medium"
        />
        <PriceTimeContainerStyled>
          <PriceStyled
            rank={2}
            text={i18n.get("pages.brands.inActiveSubscriptions.sideMenuPrice.price", infoObj && infoObj.price)}
            size="average"
          />
          {!infoObj?.CTAddOnData?.isCTStandalone && (
            <PackageTimeStyled
              rank={2}
              text={i18n.get(
                "pages.brands.inActiveSubscriptions.sideMenuPrice.packageTimeUnit",
                infoObj && infoObj.buyBrandsPackageTimeUnit
              )}
              size="default"
              type="greyLight"
            />
          )}
        </PriceTimeContainerStyled>
      </PriceContainer>
    );
  }
}

export default PriceComponent;
